
define('eteration/widgets/ui-togglepopup',[
	'knockout'
	], function(ko,widgetUtil,moment){
		

	ko.bindingHandlers.togglepopup = {
		    init: function (element, valueAccessor, allBindingsAccessor) {
		    	
		    	
		    	var toggled = undefined;
		    	
		    	if(valueAccessor && valueAccessor()){
		    		var toggled = valueAccessor().toggled;
		    	}
		    	
		    	function calendarTriggerScroll(elm, target){	    			
		    			var top, targetCSS = {},
		    				windowH = $(window).height(),
		    				windowScrollBoxHeight = windowH + $(window).scrollTop(),
		    				targetBoxHeight = false;

		    			if(target != null && target.length){ 
		    				targetCSS.height =  windowH - target.height();
		    				targetCSS.top = target.offset().top - targetCSS.height;

		    				targetBoxHeight = target.offset().top + target.height();
		    				targetCSS.height =  0;

		    				if(target.css('box-shadow') != null && target.css('box-shadow') != "none") {
		    					var css = target.css('box-shadow').match(/(-?\d+px)/g);
		    					targetCSS.top += parseInt(css[2]);
		    				}
		    				
		    			} else {
		    				targetCSS.height = 0;
		    				targetCSS.top = elm.offset().top  - 100;

		    				targetBoxHeight = windowScrollBoxHeight;
		    			}
		    			
		    			top = targetCSS.height + targetCSS.top;

		    			if( targetBoxHeight >= windowScrollBoxHeight ) {
							$('body, html').animate({
								scrollTop: top
							}, 500);
		    			}				
				}		    	
		    	
		    	$(element).on('click', function(event){
		    		var _relatedTarget = event.currentTarget;
// 					anasayfa da mini booker alanında background focus problemi için kaldırıldı. 
//		    		if ( $('.middle-wrapper').attr('style') )
//		    			$('.middle-wrapper').removeAttr('style');
		    		if ( $('.bootstrap-select').hasClass('open') )
		    			$('.bootstrap-select').removeClass('open');
		    		var oldPopups = $('.on');
		    		var self = $(this);
		    		var target = $(self.attr('href'));
		    		if(!target.length)
		    			target = $(this).closest('.popup');
		    		if (self.is('.active') )
		    			self.toggleClass('active');
		    		target.toggleClass('on');
		    		oldPopups.removeClass('on');
		    		
		    		if(toggled){
						toggled(false);
					}
		    		if(target.hasClass('on')){
						var e = $.Event('popupOpened', { relatedTarget: _relatedTarget });
						target.trigger(e).attr('tabindex', -1).attr('role', 'dialog')
					}else{
						var e = $.Event('popupClosed', { relatedTarget: _relatedTarget });
						target.trigger(e);
						$(element).focus();
					}
					if(self.attr('id') === 'calendarTrigger' || self.hasClass('scroll-to-button')){
						calendarTriggerScroll(self,target)
					}						
		    		return false;
		    	});
		    	
		    	
		    	if (screen.width >= 768) {
                    $(document).bind('click', function(event){
                        if ( !$(event.target).is('.ui-icon') ) {
                                var href = $(element).attr("href");

                                if ($(href).is(":visible") ) {                              
                                	if(!($(event.target).closest('#choosePerson').length > 0 || $(event.target).closest('#choosePersonMulticity').length > 0) && $(event.target).closest('a.showMore').length < 1){
                                        $(href).removeClass('on').trigger('popupClosed');                               
                                    }
                                    if(toggled){
                                        toggled(true);                                        
                                    }
                                }
                        }
                    });
                }
		    	
		    }
	};
	
	

		
});